module.exports = __webpack_public_path__ + "3c9588fffec174437abf2905b3a35f4b.svg";